<template>
  <div>
    <AppMembersSelector
      ref="members-user-selector"
      :organization-id="organizationId"
      :resource="resource"
      :records="['members', 'teams']"
      :changed-items="changedItems"
      :select-all-items="selectAllItems"
      multiple
      sortable
      show-select-all-trigger
      @submit-selections="selectMember"
    >
      <template #title>
        <label class="control-label">Members</label>
      </template>
    </AppMembersSelector>

    <input
      v-for="user in users"
      :key="user"
      type="hidden"
      name="filters[users][]"
      :value="user"
    />

    <input
      v-if="!!selectAll?.members"
      type="hidden"
      name="filters[select_all][members]"
      :value="!!selectAll?.members"
    />

    <input
      v-if="!!selectAll?.teams"
      type="hidden"
      name="filters[select_all][teams]"
      :value="!!selectAll?.teams"
    />
  </div>
</template>

<script>
// This component is only used within Slim template on pages such as Calendar > Schedules, Timesheets > Approval etc.
// The component does the following:
// - binds AppMembersSelector to the Slim template
// - prepares data for the selector
// - handles output of the selector and updates the page with selector's output
export default {
  name: 'FiltersMemberSelector',
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: false,
    },
    dateEnd: {
      type: String,
      required: false,
    },
    status: {
      type: String,
      required: false,
    },
    users: {
      type: Array,
      required: false,
    },
    timeOffPolicies: {
      type: Array,
      required: false,
    },
    selectAll: {
      type: Object,
      required: false,
    },
    resource: {
      type: Object,
      required: true,
    },
    redirectOnChange: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    changedItems() {
      const teams = [];
      const members = [];

      this.users?.forEach((id) => {
        if (id.includes('team:')) {
          teams.push({ id: parseInt(id.match(/\d+/)[0]), selected: !this.selectAll?.teams });
        } else {
          members.push({ id: parseInt(id), selected: !this.selectAll?.members });
        }
      });

      return {
        teams,
        members,
      };
    },
    selectAllItems() {
      return {
        members: this.selectAll?.members === 'true',
        teams: this.selectAll?.teams === 'true',
      };
    },
  },
  methods: {
    selectMember(data) {
      const params = this.url.endsWith('time_off_requests')
        ? { 'filters[date]': this.date, 'filters[date_end]': this.dateEnd, 'filters[status]': this.status }
        : { date: this.date, date_end: this.dateEnd, 'filters[status]': this.status };
      const cleanedParams = Object.fromEntries(
        Object.entries(params).filter(([, value]) => !['', null, undefined].includes(value)),
      );
      const queryString = new URLSearchParams(cleanedParams);
      const notSelectAll = !data.options.select_all.members && !data.options.select_all.teams;

      if (this.url.endsWith('time_off_requests') && this.timeOffPolicies) {
        this.timeOffPolicies.forEach((policy) => {
          queryString.append('filters[time_off_policies][]', policy);
        });
      }

      data.items.members.forEach((member) => {
        if ((notSelectAll && member.selected) || (!notSelectAll && !member.selected)) {
          queryString.append('filters[users][]', member.user_id);
        }
      });

      data.items.teams.forEach((member) => {
        if ((notSelectAll && member.selected) || (!notSelectAll && !member.selected)) {
          queryString.append('filters[users][]', `team:${member.user_id}`);
        }
      });

      Object.entries(data.options.select_all).forEach(([key, value]) => {
        if (value) {
          queryString.append(`filters[select_all][${key}]`, value);
        }
      });

      const newUrl = Array.from(queryString).length ? `${this.url}?${queryString}` : this.url;

      this.$emit('member-selection-changed', newUrl);

      if (this.redirectOnChange) {
        window.location.href = newUrl;
      }
    },
  },
};
</script>
